import { useState } from "react";

const FORM_URL = "https://readdy.ai/api/form/daftbc1tto0ceqqnhh10";

type Status = "idle" | "success" | "error";

export default function Newsletter() {
  const [status, setStatus] = useState<Status>("idle");
  const [msg, setMsg] = useState("");

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setStatus("idle");
    setMsg("");
    const form = e.currentTarget;
    const data = new FormData(form);

    // honeypot check: 若命中则静默视为成功，避免暴露反垃圾机制
    const honeypot = (data.get("phone_alt") as string) || "";
    if (honeypot.trim() !== "") {
      setStatus("success");
      form.reset();
      return;
    }
    data.delete("phone_alt");

    try {
      const res = await fetch(FORM_URL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(data as unknown as Record<string, string>).toString(),
      });
      const responseText = await res.text();
      let parsed: Record<string, any> = {};
      try {
        parsed = responseText ? JSON.parse(responseText) : {};
      } catch {
        parsed = {};
      }
      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || "";
      const bodyHasSpam =
        serverMsg.toLowerCase().includes("spam") ||
        responseText.toLowerCase().includes("spam");

      if (res.ok && parsed?.code === "OK" && !bodyHasSpam) {
        setStatus("success");
        setMsg(parsed?.meta?.message || "订阅成功，吃瓜日报马上送达你的邮箱！");
        form.reset();
      } else {
        setStatus("error");
        setMsg(serverMsg || "订阅失败，请稍后再试。");
      }
    } catch (err) {
      setStatus("error");
      setMsg("网络似乎开小差了，请稍后再试。");
    }
  };

  return (
    <section id="newsletter" className="relative overflow-hidden bg-background-50 py-14 md:py-20">
      <div className="absolute inset-0 bg-gradient-to-br from-accent-100/50 via-background-50 to-primary-100/40" aria-hidden="true"></div>
      <div className="relative mx-auto max-w-4xl px-4 text-center md:px-6">
        <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-semibold text-primary-700">
          <i className="ri-mail-open-line text-sm" aria-hidden="true"></i>
          每日精选
        </span>
        <h2 className="mt-4 font-heading text-2xl font-black text-foreground-950 md:text-4xl">
          订阅吃瓜日报，每天不错过重点
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base">
          把当日讨论度最高的事件整理成一份精简日报，每天清晨准时发送。免费订阅，随时可退。
        </p>

        <form
          data-readdy-form="吃瓜日报订阅"
          onSubmit={handleSubmit}
          className="mx-auto mt-7 flex max-w-xl flex-col gap-2 sm:flex-row"
          noValidate
        >
          <label htmlFor="newsletter-email" className="sr-only">
            邮箱地址
          </label>
          <div className="relative flex-1">
            <i className="ri-mail-line pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-lg text-foreground-400" aria-hidden="true"></i>
            <input
              id="newsletter-email"
              type="email"
              name="email"
              required
              maxLength={120}
              autoComplete="off"
              placeholder="输入你的邮箱地址"
              className="w-full rounded-full border border-background-200 bg-background-50 py-3 pl-11 pr-4 text-sm text-foreground-900 outline-none transition placeholder:text-foreground-400 focus:border-accent-400 focus:ring-2 focus:ring-accent-200"
            />
          </div>
          <button
            type="submit"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-accent-500 px-6 py-3 text-sm font-medium text-background-50 transition hover:bg-accent-600"
          >
            <i className="ri-send-plane-fill text-base" aria-hidden="true"></i>
            立即订阅
          </button>
          {/* anti-spam honeypot */}
          <div className="hp-field" aria-hidden="true">
            <label htmlFor="phone_alt_field">联系方式</label>
            <input
              id="phone_alt_field"
              type="text"
              name="phone_alt"
              tabIndex={-1}
              autoComplete="off"
              readOnly
            />
          </div>
        </form>

        <div aria-live="polite">
          {status === "success" && (
            <p className="mt-4 inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-4 py-2 text-sm font-medium text-accent-700">
              <i className="ri-checkbox-circle-fill text-accent-600" aria-hidden="true"></i>
              {msg}
            </p>
          )}
          {status === "error" && (
            <p className="mt-4 inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-4 py-2 text-sm font-medium text-primary-700">
              <i className="ri-error-warning-fill text-primary-500" aria-hidden="true"></i>
              {msg}
            </p>
          )}
        </div>

        <p className="mt-5 text-xs text-foreground-400">我们尊重你的隐私，绝不发送垃圾邮件。</p>
      </div>
    </section>
  );
}